enum ResourceStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  IN_REVIEW = "in_review",
  PRIVATE = "private",
  DEPRECATED = "deprecated",
}

export { ResourceStatus };